<template>
  <div class="userSet">
    <div class="contentCenter">
      <nav class="currentLocation">
        <ul class="display-flex">
          <li>
            <span>您的位置</span>
          </li>
          <li>
            <span @click="goUser" style="cursor: pointer;">个人中心</span>
          </li>
          <li>
            <span>设置</span>
          </li>
        </ul>
      </nav>
      <ul class="sidebar">
        <li
          v-for="item in sidebar"
          :key="item.id"
          :class="item.className"
          @click="handleSelectedNav(item)"
        >
          <div class="inner display-flex justify-content-space-between">
            <span>{{ item.name }}</span>
            <img src="../../assets/img/arrowLeft.png" alt />
          </div>
        </li>
      </ul>
      <div class="content">
        <router-view />
      </div>
    </div>
    <Modal
      width="400"
      v-model="isShowModal"
      footer-hide
      :closable="false"
      class-name="vertical-center-modal unbindModal"
    >
      <div class="unbindImg">
        <img src="../../assets/img/unbind.png" alt="" />
        <p>修改密码,请先去绑定手机号码吧!</p>
      </div>
      <img
        class="closeIcon"
        @click="isShowModal = false"
        src="../../assets/img/close.png"
      />
      <button
        @click="
          $router.push({
            path: '/userSet/phoneBind',
            query: {
              info: info,
            },
          });
          isShowModal = false;
        "
        type="button"
      >
        去绑定
      </button>
    </Modal>
  </div>
</template>

<script>
import { postData, showLoading, EventBus } from "../../assets/api/api.js";
export default {
  name: "userSet",
  components: {},
  data() {
    return {
      isShowModal: false,
      info: {},
      sidebar: [
        {
          id: 0,
          name: "用户信息",
          className: "active",
          url: "/userSet/setMyInfo",
        },
        {
          id: 1,
          name: "修改密码",
          className: "",
          url: "/userSet/editPassword",
        },
      ],
    };
  },
  watch: {
    $route(val) {
      var url = val.path;
      this.sidebar.map((i) => {
        if (
          url == "/userSet/myInfo" ||
          url == "/userSet/checkIdCar" ||
          url == "/userSet/checkAptitude" ||
          url == "/userSet/phoneBind"
        ) {
          if (i.name == "用户信息") {
            i.className = "active";
          } else {
            i.className = "";
          }
        } else if (i.url == url) {
          i.className = "active";
        } else {
          i.className = "";
        }
      });
    },
  },

  created() {
    var url = this.$route.path;
    this.sidebar.map((i) => {
      if (
        url == "/userSet/myInfo" ||
        url == "/userSet/checkIdCar" ||
        url == "/userSet/checkAptitude" ||
        url == "/userSet/phoneBind"
      ) {
        if (i.name == "用户信息") {
          i.className = "active";
        } else {
          i.className = "";
        }
      } else if (i.url == url) {
        i.className = "active";
      } else {
        i.className = "";
      }
    });
  },
  mounted() {
    EventBus.$on("getData", (data) => {
      this.info = data;
    });
  },
  computed: {},
  methods: {
    goUser() {
      this.$router.push({
        path: "/attendanceProcess/combo",
      });
    },

    handleSelectedNav(item) {
      this.$router.push({ path: item.url });
      this.sidebar.forEach((i) => {
        if (item.id == i.id) {
          i.className = "active";
        } else {
          i.className = "";
        }
      });
      this.isShowModal =
        item.url == "/userSet/editPassword" && !this.info.phone;
    },
  },
};
</script>
<style>
.editPassword #save {
  text-align: left;
}
.editPassword .ivu-input {
  height: 36px;
}
.editPassword .send .ivu-form-item-content {
  margin-left: 0 !important;
}
.editPassword .send .ivu-btn-primary {
  color: rgba(153, 153, 153, 1);
  border: 1px solid #dedbde;
  background: #dddddd;
}
.editPassword .send button {
  height: 36px;
}
.editPassword .confirm {
  margin-top: 10px;
  width: 120px;
  height: 40px;
  line-height: 40px;
  background: rgba(49, 175, 88, 1);
  border-radius: 4px;
  border: none;
}
.unbindModal {
  text-align: center;
}
</style>
<style lang="scss" scoped>
.editPassword {
  .phone {
    margin-bottom: 20px;
    width: 300px;
    text-align: left;
    margin-left: 10px;
    p {
      margin-left: 25px;
      display: inline-block;
    }
  }
  text-align: center;

  .step {
    margin-bottom: 55px;
    margin-top: 65px;
    .line {
      margin-right: 12px;
      margin-left: 12px;
      height: 1px;
      width: 57px;
      background: #a09da0;
    }
    .sFrame {
      margin-right: 8px;
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 50%;
    }
    .step1 {
      p {
        color: #31af58;
      }
      .sFrame {
        background: #31af58;
      }
    }
    .step2 {
      p {
        color: #222222;
      }
      .sFrame {
        background: #222222;
      }
    }
  }
  .code {
    width: 300px;
  }
  .send {
    width: 90px;
  }
  .from {
    display: inline-block;
    margin-bottom: 115px;
    width: 480px;
    input {
      width: 50px;
    }
  }
}
.unbindModal {
  button {
    margin-top: 25px;
    margin-bottom: 15px;
    cursor: pointer;
    outline: none;
    border: none;
    width: 100%;
    color: #fff;
    height: 40px;
    line-height: 40px;
    background: rgba(55, 188, 95, 1);
    border-radius: 3px;
  }
}
.unbindModal .closeIcon {
  cursor: pointer;
  position: absolute;
  top: -30px;
  right: -30px;
  height: 30px;
  width: 30px;
}
.unbindImg {
  padding-bottom: 15px;
  border: 1px dashed #aaa;
}
.userSet {
  .list {
    padding-bottom: 50px;
    li {
      padding: 24px;
      margin-top: 30px;
      background: #fcf9fc;
      border: 1px solid #e0dde0;
      .rg {
        color: rgba(153, 153, 153, 1);
      }
      .lf {
        .address {
          color: rgba(153, 153, 153, 1);
        }
        .name {
          color: rgba(34, 34, 34, 1);
        }

        img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          margin-right: 20px;
        }
        .header {
          border-radius: 50%;
        }
      }
    }
  }

  .content {
    margin-bottom: 30px;
    width: 962px;
    float: right;
    background: #fff;
    padding: 0 20px;
  }
}
</style>
